/**
 * @generated SignedSource<<09c74873c55136dc8e71edd2a8b49053>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeDrawerMetaAd$data = {
  readonly approved: boolean;
  readonly comments: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly created: boolean;
  readonly id: string;
  readonly submittedForApproval: boolean;
  readonly visualAssets: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"CommentList" | "CreativeAdvisorMetaAd" | "CreativeTextForm" | "MetaAdPreview">;
  readonly " $fragmentType": "CreativeDrawerMetaAd";
};
export type CreativeDrawerMetaAd$key = {
  readonly " $data"?: CreativeDrawerMetaAd$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerMetaAd">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeDrawerMetaAd",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submittedForApproval",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisualAsset",
      "kind": "LinkedField",
      "name": "visualAssets",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreativeAdvisorMetaAd"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreativeTextForm"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CommentList"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MetaAdPreview"
    }
  ],
  "type": "MetaAd",
  "abstractKey": null
};
})();

(node as any).hash = "7b73439a7133909a23dc438a45df7a12";

export default node;
